import Actions from '.';
import { post } from '../../../utils/api';
import { API_ERROR_MESSAGE } from '../../../constants';

const postUser = body => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    dispatch(Actions.updateProperty('success', false));
    try {
        const data = await post(`user/add-user`, body);
        if (data.statusCode === 201) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || 'User added successfully',
                success: true,
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message,
        }));
    }
});

export default {
    postUser,
}